import { styled } from '@mui/material';
import React from 'react';

const StyledSVG = styled('svg')({
  width: '100%',
  height: 'auto',
  maxWidth: '20px',
  fill: 'white',
});

const Mac = () => {
  return (
    <StyledSVG xmlns="http://www.w3.org/2000/svg" width="179.1" height="180" viewBox="0 0 179.1 180">
      <path d="m82.1,166l97,14v-85l-97-1s0,72,0,72ZM0,154l73,11v-71H0v60ZM0,26v61h73V15L0,26ZM178.1,0l-97,14v72l97-1V0Z" />
    </StyledSVG>
  );
};

export default Mac;
